import { Injectable } from '@angular/core';
import { ManagementStoreService } from './management-store.service';
import {SearchFilter} from '@emm/core/models/search-filter';

@Injectable({
    providedIn: 'root',
})
export class MmsAdminOverrideFacadeService {

    filteredOptions$ = this.managementStore.queryBase.all$;
    templateOptionByLocation$ = this.managementStore.queryMmsAdminOverride.templateOptionsByLocation$;
    templateOptionByLocationAsNode$ = this.managementStore.queryMmsAdminOverride.templateOptionsByLocation$;
    templateByLocation$ = this.managementStore.queryMmsAdminOverride.templateByLocation$;
    centerLoading$ = this.managementStore.isLoading$.mmsAdminOverride;

    constructor(private managementStore: ManagementStoreService) {}

    init(): void {
        this.managementStore.dispatch.initMmsAdmin();
    }

    searchLocation(searchFilter: SearchFilter): void {
        this.managementStore.dispatch.searchLocation(searchFilter);
    }

    selectedLocation(selected): void {
        this.managementStore.dispatch.selectLocation(selected);
    }

    saveTemplateSelections(selections, storeNumber, selectedEffectiveDate) {
        this.managementStore.dispatch.savedSelections(selections, storeNumber, selectedEffectiveDate);
    }
}
